// extracted by mini-css-extract-plugin
export var header = "MinimalHeader-module__header___HvuUO";